//@flow
import ImageCompressor from "image-compressor.js";
import Compressor from "compressorjs";
import { isNumeric } from "../helpers/regex";
import _, { forEach } from "lodash"
import moment from "moment";
import {
  MANDIRI_CREDIT_CARD,
  MANDIRI_DEBIT_CARD,
  CREDITCARD,
  INSTALLMENTS,
  BCA_INSTALLMENTS,
  BANKTRANSFER,
  MANDIRI_VA,
  BCA_VA,
  PERMATA_VA,
  BNI_VA,
  BRI_VA,
  VIRTUALACCOUNT,
  FULLWALLET,
  BCA_CREDIT_CARD,
  BNI_CREDIT_CARD,
  BNI_DEBIT_CARD,
  BCA_KLIK_PAY,
  BCA_ONEKLIK,
  GOPAY,
  KREDIVO,
  ATOME,
  AKULAKU
} from '../constants/paymentMethods';
import {
  _PENDING_REFUND,
  _PENDING_PAYMENT,
  _ON_CANCEL,
  _VERIYING_PAYMENT,
  _COMPLETED,
  _NEW,
  _SELLER_SENT,
  _KA_RECEIVED,
  _VERIFIED_PASS,
  _VERIFIED_FAIL,
  _SENT_BUYER,
  ON_COURIER,
  ON_DONE,
  ADMINISTRATOR,
  UNDER_REVIEW,
  REJECTED,
  EXPIRED,
  _REFUNDED,
  _DONE_BY_BUYER,
  _DONE_BY_ADMIN,
  _DONE_BY_CRON,
  _VERIFYING_BID,
  CANCELLED
} from "../utils";

import SNEAKERS_IMG from '../images/sneakers1024.png';
import APPARELS_IMG from '../images/streetwear1024.png';
import LIFESTYLES_IMG from '../images/lifestyle1024.png';
import HANDBAGS_IMG from '../images/luxury1024.png';
import TICKETS_IMG from '../images/ticket1024.png';

import EMPTY_SNEAKERS_IMG from '../images/emptysneakers.png';
import EMPTY_APPARELS_IMG from '../images/emptyapparels.png';
import EMPTY_HANDBAGS_IMG from '../images/emptyhandbags.png';
import EMPTY_LIFESTYLE_IMG from '../images/emptylifestyles.png';

import EMPTY_IMAGE from '../images/kick_avenue_empty_image.png';

/**
 * Get image category
 * @param {string} category
 * @return {string} category image
 */
export function getImageCategory(category: string) {
  switch (category) {
    case 'sneakers':
      return SNEAKERS_IMG;
    case 'apparels':
      return APPARELS_IMG;
    case 'streetwear':
    case 'fashion':
    case 'apparel':
      return APPARELS_IMG;
    case 'lifestyles':
    case 'lifestyle':
    case 'toys':
    case 'electronics-collectibles':
      return LIFESTYLES_IMG;
    case 'luxury':
      return HANDBAGS_IMG;
    case 'handbags':
      return HANDBAGS_IMG;
    case 'Tickets':
      return TICKETS_IMG;
    default:
      return SNEAKERS_IMG;
  }
}

export function handleImageCategory(isTicket: bool, category: string) {
  if (isTicket) {
    return getImageCategory('Tickets')
  } else {
    return getImageCategory(category)
  }
}

// Function to get jwt payloads from token
export const jwtPayloads = token => {
  let tokenSplits = token.split(".");
  if (tokenSplits.length) return tokenSplits[1];
  return false;
};

// Function to decode jwt payloads
export const jwtDecode = payloads => {
  if (payloads.length) return window.atob(payloads);
  return false;
};

/**
 * JavaScript Code Snippet
 * Convert Number to Rupiah & vice versa
 * https://gist.github.com/845309
 *
 * Copyright 2011-2012, Faisalman
 * Licensed under The MIT License
 * http://www.opensource.org/licenses/mit-license
 *
 */

export function capitalizeFirstLetter(text) {
  if (!text || typeof text !== "string") return ""

  return text.charAt(0).toUpperCase() + text.slice(1);
}

export const capitalizeSentence = (text) => {
  if (!text || typeof text !== "string") return ""

  let result = "";

  const splittedText = text.split(" ");

  const _mapString = splittedText.map(_text => {
    if (!_text) return "";

    let lower = _text.toLowerCase();

    let upper = lower?.[0].toUpperCase() + lower.substring(1);
    return upper
  })


  return _mapString.join(" ")
}

export const convertToRupiah = angka => {
  var rupiah = "";
  var angkarev = angka
    .toString()
    .split("")
    .reverse()
    .join("");
  for (var i = 0; i < angkarev.length; i++)
    if (i % 3 === 0) rupiah += angkarev.substr(i, 3) + ".";
  return angka >= 0 ? rupiah
    .split("", rupiah.length - 1)
    .reverse()
    .join("") : rupiah
      .split("", rupiah.length - 1)
      .reverse()
      .join("").replace(".", "");
};

export function formatNumber(num, precision = 0) {
  if (!num) {
    return "0";
  }
  return parseFloat(num)
    .toFixed(precision)
    .toString()
    .replace(/\B(?=(\d{3})+(?!\d))/g, ",");
}

export function formatRupiah(num, precision = 0) {
  if (!num) {
    return "0";
  }
  return parseFloat(num)
    .toFixed(precision)
    .toString()
    .replace(/\B(?=(\d{3})+(?!\d))/g, ".");
}

export function formatCurrency(num, ratio = 1, currency = "IDR") {
  let precision = ratio === 1 ? 0 : 2;
  const convToNum = (typeof num === 'string') ? convertToAngka((num.substr(num.length - 3, 3) === '.00') ? num.substr(0, num.length - 3) : num) : num;
  if (!num) {
    return "0";
  }
  return `${currency} ${formatNumber(convToNum * ratio, precision)}`;
}

export function formatCurrencyV2(num, ratio = 1, currency = "IDR") {
  let precision = ratio === 1 ? 0 : 2;
  const convToNum = (typeof num === 'string') ? convertToAngka((num.substr(num.length - 3, 3) === '.00') ? num.substr(0, num.length - 3) : num) : num;
  if (!num) {
    return "0";
  }
  return ` ${formatNumber(convToNum * ratio, precision)}`;
}

export function formatCurrencyRupiah(num, ratio = 1, currency = "IDR") {
  let precision = ratio === 1 ? 0 : 2;

  if (!num) {
    return "0";
  }
  return `${currency} ${formatRupiah(num * ratio, precision)}`;
}

export function formatCurrencyWithMinus(num, ratio = 1, currency = "IDR") {
  let precision = ratio === 1 ? 0 : 2;
  let curr = currency === "Rp" ? "IDR" : currency;

  if (!num) {
    return "IDR 0";
  }
  return `${(+num < 0) ? '-' : ''} ${curr} ${formatRupiah(Math.abs(num) * ratio, precision)}`;
}

export const getRetailPrice = (currency, price) => {
  let retailPrice = parseInt(price);

  if (currency === "USD") {
    return `$ ${convertToRupiah(retailPrice)} USD (approx.)`;
  } else {
    return `IDR ${convertToRupiah(retailPrice)}`;
  }
};

/**
 * Usage example:
 * alert(convertToRupiah(10000000)); -> "IDR. 10.000.000"
 */

export const convertToAngka = rupiah => {
  return parseInt(rupiah.replace(/,.*|[^0-9]/g, ""), 10);
};

export const convertOftheDay = (date_time, option = false) => {
  let newDate = new Date(date_time);
  return `${newDate.toLocaleString("in-ID", {
    day: "numeric",
    month: "long",
    year: "numeric"
  })}`;
};

export const remaining_time = expired => {
  var now = new Date();
  var time_expired = new Date(expired);
  let distance = time_expired.getTime() - now.getTime();

  // Time calculations for days, hours, minutes and seconds
  var days = Math.floor(distance / (1000 * 60 * 60 * 24));
  var hours = Math.floor((distance % (1000 * 60 * 60 * 24)) / (1000 * 60 * 60));
  var minutes = Math.floor((distance % (1000 * 60 * 60)) / (1000 * 60));
  var seconds = Math.floor((distance % (1000 * 60)) / 1000);

  return { distance, days, hours, minutes, seconds };
};

export const getTimeExpired = expired => {
  var time_expired = new Date(expired);

  return time_expired.getTime();
};

export function getRolesUtils(userJwtPayload) {
  if (userJwtPayload) {
    const { roles } = JSON.parse(jwtDecode(userJwtPayload));
    return roles ? roles.split(",") : [];
  }
  return "";
}

export const countUpTime = (countTo) => {
  let now = new Date();
  let from_update_at = new Date(countTo);
  let difference = now - from_update_at;
  //Time Calculating For Forward Time
  let days = Math.floor((difference / (60 * 60 * 1000 * 24)) * 1);
  let hours = Math.floor(
    ((difference % (60 * 60 * 1000 * 24)) / (60 * 60 * 1000)) * 1
  );
  let mins = Math.floor(
    (((difference % (60 * 60 * 1000 * 24)) % (60 * 60 * 1000)) / (60 * 1000)) *
    1
  );
  let secs = Math.floor(
    ((((difference % (60 * 60 * 1000 * 24)) % (60 * 60 * 1000)) % (60 * 1000)) /
      1000) *
    1
  );

  return {
    days,
    hours,
    mins,
    secs
  };
  // return `${days} Hari ${hours} Jam ${mins} Menit ${secs} Detik`
};

// Images Compressor function
export const ImagesCompressor = async file => {
  try {
    const maxSize = 1000000; // byte
    const originSize = file.size; // origin size
    let isQuality = maxSize < originSize ? 0.6 : 1;

    return new Promise((resolve, reject) => {
      new Compressor(file, {
        quality: isQuality,
        success(result) {
          resolve(result);
        },
        error(err) {
          reject(err);
        }
      });
    });
  } catch (e) {
    return file;
  }
  // console.log('KUALITAS ', isQuality.toFixed(1));

  // const compressor = imageCompressing.compress(file, {
  //   quality: isQuality
  // })
  // .then(result => {
  //   return result;
  // })
  // .catch(error => error)

  //return compressor;
};

export const hasError = (errors, propsName) =>
  errors && Object.keys(errors).filter(key => key === propsName).length > 0;

export const addError = (errors, propsName, value) =>
  hasError(errors, propsName) ? [...errors[propsName], value] : [value];

export const hasErrorArray = (array, objHasError) => {
  for (let i = 0; i < array.length; i++) {
    const isError = hasError(objHasError, array[i]);
    if (isError) {
      return isError;
    }
  }
  return false;
};

export const parsePhone = (phone, isRemoved = true, prefix) => {
  const regex = new RegExp(`(^0)|(^${prefix})|(^\\+${prefix})`);
  const parsed = phone ? phone.replace(regex, "") : '';
  return isRemoved ? parsed : `+${prefix}${parsed}`;
};

export const parsePhoneCode = phoneNumber => {
  const sliced = phoneNumber.slice(1, 3);
  return sliced;
};

export const getFileExt = fileName =>
  fileName.indexOf(".")
    ? fileName.substring(fileName.lastIndexOf(".") + 1, fileName.length)
    : null;

export const isFromAppBrowser = () => {
  let documentReferral = document.referrer;
  let userAgent = navigator.userAgent;

  //let isReferralFromInternalSite = (/168|localhost|kickavenue/i).test(documentReferral)

  let isRefferalFrom = /telegram|whatsapp|facebook|instagram|twitter/i.test(
    documentReferral
  );
  let isUserAgentFromApp = /telegram|whatsapp|facebook|instagram|twitter/i.test(
    userAgent
  );

  return isRefferalFrom || isUserAgentFromApp;
};

export const isFromKickApp = () => {
  const isFromApp = navigator.userAgent.includes("KickAvenueApp");

  return isFromApp;
};

export const getCloudImageUrl = (imageUrl, width, type) => {
  var base64 = require("base-64");

  if (imageUrl === "" || !imageUrl) return "";

  if (imageUrl.indexOf("s3.amazonaws.com") === -1) return imageUrl;

  const isSafari =
    /constructor/i.test(window.HTMLElement) ||
    (function (p) {
      return p.toString() === "[object SafariRemoteNotification]";
    })(
      !window["safari"] ||
      (typeof safari !== "undefined" && window["safari"].pushNotification)
    );
  const isMacintosh = navigator.userAgent.includes("Macintosh");

  const domainRegex = /(?:http[s]*\:\/\/)*(.*?)\.(?=[^\/]*\..{2,5})/i;
  const bucket = domainRegex.exec(imageUrl)[1];
  const uri = imageUrl.replace(`https://${bucket}.s3.amazonaws.com/`, "");
  let format = {};

  if ((isSafari && isMacintosh) || type === "product-image") {
    format = {};
  } else {
    format = {
      webp: {
        quality: type === "carousel" ? 100 : 50
      }
    };
  }

  const cloudImageUrl = JSON.stringify({
    bucket,
    key: decodeURIComponent(uri),
    edits: {
      resize: {
        width
      },
      ...format
    }
  });
  const newImagePath = base64.encode(cloudImageUrl);
  return "https://d5ibtax54de3q.cloudfront.net/" + newImagePath;
};

export const roundUpPrice = (from, to) => {
  if (isNumeric(from)) {
    let parsed = parseFloat(from);
    if (parsed <= to) return to;
    parsed -= from % to;
    const roundUp = parsed + to;
    return from % to === 0 ? parsed : roundUp;
  }
  return from;
};

export const normalizeBrand = brand => {
  if (brand) {
    return brand
      .replace(/Handbags/gi, "")
      .replace(/Bags/gi, "")
      .replace(/\s*$/, "");
  }
  return brand;
};

export const isFile = file => file instanceof File;
export const blobToFile = theBlob => {
  return new File(
    [theBlob],
    (+new Date() + Math.random() * 100).toString(32).replace(".", ""),
    { type: theBlob?.type, lastModified: Date.now() }
  );
};

export const sneakersCondition = condition => {
  switch (condition) {
    case "BARU":
      return "Brand New";
    case "BEKAS":
      return "Used";
    case "PREORDER":
      return "Pre-Order";
    case "PREVERIFIED":
      return "Express Shipping";
    case "PRISTINE":
      return "Pristine";
    case "GOOD":
      return "Good";
    case "WELL_USED":
      return "Well Used";
    case "LIKE_NEW":
      return "Like New";
    case "VINTAGE":
      return "Vintage";
    default:
      return "Brand New";
  }
};

export const sneakersConditionValue = value => {
  switch (value) {
    case "BARU":
      return "new";
    case "BEKAS":
      return "used";
    case "PREORDER":
      return "pre_order";
    case "PREVERIFIED":
      return "pre_verified";
    case "PRISTINE":
      return "pristine";
    case "GOOD":
      return "good";
    case "WELL_USED":
      return "well_used";
    case "LIKE_NEW":
      return "like_new";
    case "VINTAGE":
      return "vintage";
    default:
      return "new";
  }
};

export const sneakersConditionUrl = value => {
  if (value === "pre_verified") {
    return "express_shipping"
  }
  switch (value) {
    case value:
      return value;
    default:
      return "new";
  }
};

export const sneakersConditionKey = value => {
  if (value === "express_shipping") {
    return "pre_verified"
  }
  switch (value) {
    case value:
      return value;
    default:
      return "new";
  }
};

export const sneakersConditionText = value => {
  switch (value) {
    case "new":
      return "Brand New";
    case "used":
      return "Used";
    case "pre_order":
      return "Pre-Order";
    case "pre_verified":
    case "express_shipping":
      return "Express Shipping";
    case "pristine":
      return "Pristine";
    case "good":
      return "Good";
    case "well_used":
      return "Well Used";
    case "like_new":
      return "Like New";
    case "vintage":
      return "Vintage";
    default:
      return "Brand New";
  }
}

export const accessoriesCondition = data => {
  switch (data) {
    case false:
      return "Complete Accessories";
    case true:
      return "Missing Accessories";

    default:
      return "Complete Accessories";
  }
};

export const yellowing = data => {
  switch (data) {
    case false:
      return "";
    case true:
      return "Yellowing";

    default:
      return "";
  }
};

export const displayItem = data => {
  switch (data) {
    case false:
      return "";
    case true:
      return "Display Item";

    default:
      return "";
  }
};

export const sneakersDefect = data => {
  switch (data) {
    case false:
      return "";
    case true:
      return "Defect from Manufacture";

    default:
      return "";
  }
};

export const boxCondition = condition => {
  switch (condition) {
    case "SEMPURNA":
      return "Perfect Box";
    case "CACAT":
      return "Damaged Box";
    case "NO_BOX":
      return "Missing Box";

    default:
      return "Perfect Box";
  }
};

export const defectCondition = (bool, data) => {
  switch (bool) {
    case true:
      return detailCondition(data);
    case false:
      return `${sneakersCondition(
        data.sneakers_condition
      )} / Perfect Condition`;

    default:
      return "Perfect Condition";
  }
};

export const detailCondition = data => {
  if (data.hasOwnProperty('user_sell') && data.user_sell !== null && data.user_sell.hasOwnProperty('defects')) {
    const condition = data.user_sell.defects
      .filter(item => item.value)
      .map(item => item.display_name)
      .join(" / ");

    return `${sneakersCondition(data.sneakers_condition)} , ${condition}`;
  }
  return;
};

export const handbagCondition = (data, separator = ' / ') => {
  return detailHandbagCondition(data, separator);
};

export const detailHandbagCondition = (data, separator = ' / ') => {
  const condition = data
    .filter(item => item.value)
    .map(item => item.display_name)
    .join(separator);

  return condition;
};

export const sneakerDefectsCondition = (data, separator = ' / ') => {
  return detailSneakerDefects(data, separator);
};

export const detailSneakerDefects = (data, separator = ' / ') => {
  const condition = data
    .filter(item => item.value === true)
    .map(item => item.display_name)
    .join(separator);

  return condition;
};

export const boxHandbag = value => {
  if (value) {
    return "";
  } else {
    //return empty string since box handbag is already in defects/inclusions
    return "";
    // return "Missing Box";
  }
};

export const dustBag = value => {
  if (value) {
    return "";
  } else {
    return "KA Dust Bag";
  }
};

export const handleProductConditions = (product, category) => {
  if (!product) return ""
  const {
    missing_accessories,
    sneakers_defect,
    sneakers_condition,
    yellowing,
    display_item,
    defects,
    box_condition,
    hide_box_info
  } = product || {}

  const uniqueDefects = _.uniqBy(defects, "name");
  const dustBagCondition = uniqueDefects
    ? uniqueDefects.find(a => a.name === "DUST_BAG")
    : {};
  const boxConditions = uniqueDefects
    ? uniqueDefects.find(a => a.name === "BOX")
    : {};
  const boxConditionNew = hide_box_info
    ? null
    : boxCondition(box_condition);
  const productDefects = uniqueDefects.length > 0 ? uniqueDefects.filter(item => item.value).map(item => item.display_name) : [];

  const generalConditions = [
    sneakersCondition(sneakers_condition),
    boxConditionNew,
    accessoriesCondition(missing_accessories),
    yellowing ? "Yellowing" : null,
    sneakers_defect ? "Defect" : null,
    display_item ? "Display Item" : null
  ];
  const ProductConditions = [...generalConditions, ...productDefects];
  const productConditionDetail = ProductConditions
    .filter(item => item !== null)
    .map(item => item)
    .join(", ");

  const luxuryDetailArr = [
    sneakersCondition(sneakers_condition),
    accessoriesCondition(missing_accessories),
    dustBag(dustBagCondition && dustBagCondition.value),
    boxHandbag(boxConditions),
    sneakers_defect ? handbagCondition(uniqueDefects) : ""
  ];
  const luxuryDetail = luxuryDetailArr
    .filter(item => item !== "" && item !== "Missing Box")
    .map(item => item)
    .join(", ");

  return category === "handbags" ? luxuryDetail : productConditionDetail
};

export const estimatedTimeArrivals = (pre_verified, isEventActive, condition, text = {}) => {
  const {
    eta_standard,
    eta_preverified,
    eta_preverified_event,
    eta_preorder
  } = text || {}

  return (pre_verified && isEventActive)
    ? `${eta_preverified_event ?? ""}` :
    (pre_verified && !isEventActive)
      ? `${eta_preverified ?? ""}`
      : condition === "PO"
        ? `${eta_preorder ?? ""}`
        : `${eta_standard ?? ""}`
}

export const parseKeyword = (string, symbol = "+") => {
  return string
    .replace(/[^a-zA-Z0-9\_|+ -]\s+/g, "")
    .toLowerCase()
    .trim()
    .split(" ")
    .join(symbol);
};

//TODO: PLEASE INVESTIGATE THIS WHY THIS IS NOT WORKS
export const emptyImage = category => {
  switch (category) {
    case "sneakers":
    case "apparels":
    case "handbags":
    case "luxury":
    case "lifestyle":
    case "toys":
    case "electronics-collectibles":
    case "lifestyles":
    case "electronics-collectibles":
      return EMPTY_IMAGE;

    default:
      return EMPTY_IMAGE;
  }
};

export const _getStatusPurchase = ({ sale, status, expiry }) => {
  if (
    remaining_time(expiry).distance < 0 &&
    (status === _PENDING_PAYMENT[0] || status === _VERIFYING_BID[0])
  )
    return EXPIRED[2];

  switch (status) {
    case _PENDING_PAYMENT[0]:
      return _PENDING_PAYMENT[2];
    case _VERIYING_PAYMENT[0]:
      return _VERIYING_PAYMENT[2];
    case _COMPLETED:
      return _sellerToBuyer(sale[0]);
    case ON_COURIER:
      return ON_COURIER[1];
    case ON_DONE:
      return ON_DONE[1];
    case _ON_CANCEL[0]:
      return sale.length > 0 ? _ON_CANCEL[2] : _ON_CANCEL[3];
    case _PENDING_REFUND[0]:
      return _PENDING_REFUND[2];
    case _REFUNDED[0]:
      return _REFUNDED[2];
    case EXPIRED[0]:
      return EXPIRED[2];
    case _VERIFYING_BID[0]:
      return _VERIFYING_BID[2];
    default:
      return ADMINISTRATOR[1];
  }
};

const _sellerToBuyer = ({
  status,
  seller_responded,
  customer_received,
  completed,
  ka_sent,
  seller_awb_number
}) => {
  switch (status) {
    case _NEW[0]:
      return seller_responded ? ON_COURIER[3] : _NEW[2];
    case _SELLER_SENT[0]:
      return seller_awb_number ? _SELLER_SENT[2] : ON_COURIER[3];
    case _ON_CANCEL[0]:
      return _ON_CANCEL[2];
    case _KA_RECEIVED[0]:
      return _KA_RECEIVED[1];
    case _VERIFIED_PASS[0]:
      return _VERIFIED_PASS[2];
    case _VERIFIED_FAIL[0]:
      return _VERIFIED_FAIL[2];
    case _SENT_BUYER[0]:
      return ka_sent ? _SENT_BUYER[2] : "Awaiting shipment";
    case _DONE_BY_BUYER:
      return ON_DONE[1];
    case _DONE_BY_ADMIN:
      return ON_DONE[1];
    case _DONE_BY_CRON:
      return ON_DONE[1];
    case UNDER_REVIEW[0].toUpperCase():
      return UNDER_REVIEW[1];
    default:
      return ADMINISTRATOR[1];
  }
};

export const printError = (e) => {
  let errorMessage = "";

  if (!e) return "";

  if (!e.errors) {
    if (e.error && e.error.message) errorMessage = e.error.message;
    else errorMessage = e.message;
  } else {
    let { errors } = e;

    for (let idx in errors) {
      let message = errors[idx];

      if (message instanceof Array) {
        message.map((m) => {
          if (m instanceof Object) errorMessage += m.message + "\n";
          else errorMessage += m + "\n";
        });
      } else {
        errorMessage += message + "\n";
      }
    }
  }

  if (errorMessage === "Your previous cashout is still in process. Please wait for a moment") return errorMessage = "Please wait until your on going request is approved."
  if (errorMessage === "The password field is invalid.") return errorMessage = "Incorrect password."

  return errorMessage;
}

export function printErrorNew(e) {
  let errorMessage = "";

  if (!e) return "";

  if (!e.errors) {
    if (e.error && e.error.message) errorMessage = e.error.message;
    else errorMessage = e.message;
  } else {
    let { errors } = e;

    for (let idx in errors) {
      let message = errors[idx];

      if (message instanceof Array) {
        message.map((m) => {
          if (m instanceof Object) errorMessage += m.message + "\n";
          else errorMessage += m + "\n";
        });
      } else {
        errorMessage += message + "\n";
      }
    }
  }

  if (errorMessage.includes("timeout"))
    errorMessage =
      "It’s taking too long to load, please check your internet connection and try again";

  if (errorMessage.includes("Token has expired"))
    errorMessage = "Sorry, your session has expired. Please login again.";

  if (errorMessage.includes("Token not provided"))
    errorMessage = "Sorry, your session has expired. Please login again.";

  if (errorMessage.includes("Shoes stock is not enough"))
    errorMessage =
      "Sorry! Your product is no longer available. Please press Refresh to get the latest prices.";

  return errorMessage;
}
export const textValue = (name, obj = {}) => {
  return (
    (obj[name] === undefined
      || obj[name] === null) ? '' :
      obj[name]
  )
}

export const categoryString = (category = "") => {
  switch (category) {
    case "sneakers":
      return "sneakers"
    case "streetwear":
    case "fashion":
    case "apparels":
    case "apparel":
      return "apparels"
    case "luxury":
    case "handbags":
      return "handbags"
    case "lifestyle":
    case "toys":
    case "electronics-collectibles":
    case "lifestyles":
      return "lifestyles"

    default: return "sneakers"
  }
}

export const categorySearch = (category = "") => {
  switch (category) {
    case "sneakers":
      return "sneakers"
    case "streetwear":
    case "fashion":
    case "apparel":
      return "apparels"
    case "luxury":
      return "handbags"
    case "lifestyle":
    case "toys":
    case "electronics-collectibles":
      return "lifestyles"
    case 'madeindonesia':
      return 'madeindonesia';
    default: return "all_category"
  }
}

export const categoryURL = (category = "") => {
  switch (category) {
    case "sneakers":
      return "sneakers"
    case "apparels":
    case "fashion":
    case "apparel":
      return "apparel"
    case "handbags":
    case "luxury":
      return "luxury"
    case "lifestyles":
    case "toys":
    case "electronics-collectibles":
      return "electronics-collectibles"
    default:
      return "sneakers"
  }
}

export const categoryURLSearchPage = (category = "") => {
  switch (category) {
    case "sneakers":
      return "sneakers"
    case "apparels":
    case "streetwear":
    case "fashion":
    case "apparel":
      return "apparel"
    case "handbags":
    case "luxury":
      return "luxury"
    case "lifestyles":
    case "lifestyle":
    case "toys":
    case "electronics-collectibles":
      return "electronics-collectibles"
    case "madeindonesia":
      return "madeindonesia"
    default: return "sneakers"
  }
}

export const categoryText = (category = "") => {
  switch (category) {
    case "sneakers":
      return "Sneakers"
    case "apparel":
    case "apparels":
    case "streetwear":
    case "fashion":
    case "apparel":
      return "Apparel"
    case "handbags":
    case "luxury":
      return "Luxury"
    case "lifestyles":
    case "lifestyle":
    case "toys":
    case "electronics-collectibles":
      return "Electronics & Collectibles"
    case "madeindonesia":
      return "MadeIndonesia"
    default: return "Sneakers"
  }
}

export const genderSearchPage = (gender) => {
  switch (gender) {
    case "M":
      return "Men"
    case "F":
      return "Women"
    case "Y":
    case "GS":
      return "Youth"
    case "U":
      return "Unisex"
    default: return "Men"
  }
}

export const colorSearchPage = (value) => {
  switch (value) {
    case "red":
      return "Red"
    case "black":
      return "Black"
    case "blue":
      return "Blue"
    case "white":
      return "White"
    case "green":
      return "Green"
    case "brown":
      return "Brown"
    case "yellow":
      return "Yellow"
    case "gray":
      return "Gray"
    case "gold":
      return "Gold"
    case "pink":
      return "Pink"
    case "purple":
      return "Purple"
  }
}

export const handlePaymentMethodText = (payment, via, bank_code = "") => {
  let firstText = '';
  let secondtext = '';
  switch (payment) {
    case MANDIRI_CREDIT_CARD:
      firstText = 'MANDIRI Credit Card';
      secondtext = '';
      break;
    case MANDIRI_DEBIT_CARD:
      firstText = 'MANDIRI Debit Card';
      secondtext = '';
      break;
    case CREDITCARD:
    case INSTALLMENTS:
      firstText = '';
      secondtext = 'Credit / Debit Card';
      break;
    case BCA_INSTALLMENTS:
      firstText = 'BCA Installments';
      secondtext = '';
      break;
    case BANKTRANSFER:
      firstText = 'Bank Transfer';
      secondtext = '';
      break;
    case MANDIRI_VA:
      firstText = 'MANDIRI';
      secondtext = 'Virtual Account';
      break;
    case BCA_VA:
      firstText = 'BCA';
      secondtext = 'Virtual Account';
      break;
    case PERMATA_VA:
      firstText = 'PERMATA';
      secondtext = 'Virtual Account';
      break;
    case BNI_VA:
      firstText = 'BNI';
      secondtext = 'Virtual Account';
      break;
    case BRI_VA:
      firstText = 'BRI';
      secondtext = 'Virtual Account';
      break;
    case GOPAY:
      firstText = 'GOPAY';
      secondtext = '';
      break;
    case VIRTUALACCOUNT:
      if (via === 'xnd') {
        firstText = 'Other';
        secondtext = 'Virtual Account';
      } else {
        if (bank_code) {
          firstText = bank_code;
          secondtext = 'Virtual Account';
        } else {
          firstText = 'BCA';
          secondtext = 'Virtual Account';
        }
      }
      break;
    case FULLWALLET:
      firstText = 'Kick Credit';
      secondtext = '';
      break;
    case BCA_CREDIT_CARD:
      firstText = 'BCA';
      secondtext = 'Credit Card';
      break;
    case BNI_CREDIT_CARD:
      firstText = 'BNI';
      secondtext = 'Credit Card';
      break;
      case BNI_DEBIT_CARD:
        firstText = 'BNI';
        secondtext = 'Debit Card';
        break;
    case KREDIVO:
      firstText = 'Kredivo';
      secondtext = '';
      break;
    case ATOME:
      firstText = 'Atome';
      secondtext = '';
      break;
    case AKULAKU:
      firstText = 'Akulaku';
      secondtext = '';
      break;
    case BCA_KLIK_PAY:
      firstText = 'BCA';
      secondtext = 'Klik Play';
      break;
    case BCA_ONEKLIK:
      firstText = 'BCA';
      secondtext = 'One Klik';
      break;
    default:
      firstText = '';
      secondtext = '';
      break;
  }
  return secondtext + ' - ' + firstText;
};
/* HIDE NAVBAR SUB SAAT DI PRODUCT DETAIL ATAU CHECKOUT/MAKE OFFER ATAU DASHBOARD MENU MOBILE */
export const hideNavbarSub = (url) => {
  const splitedLocation = url.split("/")
  let result = false

  const isInProductDetails = ["sneakers", "streetwear", "fashion", "apparel", "luxury", "lifestyles"].includes(splitedLocation[1])
  const isHaveNumber = isNaN(Number(splitedLocation[2]))
  const isInCheckout = splitedLocation.includes("checkout")
  const isInMakeOffer = splitedLocation.includes("offer")
  const isInDashboardMenuMobile = splitedLocation.length === 2 && splitedLocation[1] === 'user_dashboard';
  if ((isInProductDetails && !isHaveNumber) || isInCheckout || isInMakeOffer || isInDashboardMenuMobile) {
    return true
  }
  return false
}

export const CopyToClipboard = (val) => navigator.clipboard.writeText(val);

export const getTimezone = () => {
  const GMT = moment().format("ZZ");

  switch (GMT) {
    case "+0700": return "WIB"
    case "+0800": return "WITA"
    case "+0900": return "WIT"
    default: return ""
  }
}

export const dateHandler = (date) => {
  try {
    const splittedDate = date.split("");
    let tanggal = "";
    let suffix = "";

    splittedDate.forEach(val => {
      if (isNaN(Number(val))) {
        suffix += val;
        return;
      }
      tanggal += val;
    })

    return [tanggal, suffix]
  } catch (err) {
    console.log(err, "Error Helper.js fn dateHandler")
    return ["", ""]
  }
}

export const momentHandler = (date, formatter) => {
  try {
    return moment(date).format(formatter)
  } catch (err) {
    console.log(err, "Error Helper.js fn momentHandler")
    return ""
  }
};

export const timeslotHelper = (data) => {
  try {
    if (!Array.isArray(data) || !data?.length) return null;

    const timeArr = [...data]

    const result = {}

    timeArr.forEach(val => {
      const day = momentHandler(val.start_time, 'dddd');
      const month = momentHandler(val.start_time, 'MMM');
      const date = momentHandler(val.start_time, 'Do');
      const start_hour = momentHandler(val.start_time, 'HH:MM');
      const end_hour = momentHandler(val.end_time, 'HH:MM');

      const combine = day + ', ' + month + ' ' + date;

      if (!result[`${combine}`]) {
        result[`${combine}`] = {
          timeslot: [
            {
              start_time: val.start_time,
              end_time: val.end_time,
              start_hour,
              end_hour
            }
          ],
          day,
          month,
          date: dateHandler(date)
        }
      } else {
        result[`${combine}`] = {
          ...result[`${combine}`],
          timeslot: [
            ...result[`${combine}`].timeslot,
            {
              start_time: val.start_time,
              end_time: val.end_time,
              start_hour,
              end_hour
            }
          ]
        }
      }
    })

    return result;
  } catch (err) {
    console.log(err, "Error Helper.js fn timeslotHelper")
    return null;
  }
};

export const isDatePassedHandler = (date) => {
  try {
    return moment().isAfter(date)
  } catch (err) {
    console.log(err, "Error helper js fn isDatePassedHandler")
    return null
  }
}

export const convertBrandNameToSlug = (param) => {
  if (!param || typeof param !== "string") {
    return "";
  }

  return param.toLowerCase().replaceAll(" ", "-");
}

export const convertToPreVerified = (queries) => {
  Object.keys(queries).forEach((item) => {
    if (typeof typeof queries[item] == "string" && queries[item] === "express_shipping") {
      queries[item] = "pre_verified"
    }
  })
  return queries
}

export const isExpressShippingFiltered = param => {
  const expressShippingValue = ['express_shipping', 'pre_verified'];

  return expressShippingValue.includes(param);
}

export const handleStatusConsignment = (item, type) => {
  if (type === 'pending') {
    
    if (item.is_expired === true) {
      return 'Expired'; 
    }

    const sellConsignments = item.sell_consignments;
    const forceCancelled = Boolean(sellConsignments?.force_cancelled_at);
    const hasAwbNumber = Boolean(sellConsignments?.ka_awb_number);
    const isTakeOutRequest = forceCancelled && !hasAwbNumber;

    if (isTakeOutRequest) {
      return 'Take Out Request';
    }

    if (sellConsignments?.status === 'VERIFICATION_FAILED') {
      return 'Verification Failed';
    }

    if (sellConsignments?.status === 'VERIFICATION_PASSED') {
      if(sellConsignments?.rack_name){
        return 'Verification Passed';
      }

      return 'Authentication Process';
    }

    if (sellConsignments?.status === 'KA_RECEIVED') {
      return 'Authentication Process';
    }

    const isReturnedToSeller = sellConsignments?.status === 'KA_RETURNED_SELLER';
    const isOnTheWayToYou = isReturnedToSeller && hasAwbNumber;

    if (isOnTheWayToYou) {
      return 'On The Way To You';
    }

    if (sellConsignments?.status === 'KA_RETURNED_SELLER') {
      return 'Verification Failed';
    }

    if (sellConsignments?.status === 'SELLER_SENT') {
      return 'En Route to Kick Avenue';
    }

    const shipperStatuses = [
      'PICKUP_REQUESTED',
      'PICKED_UP',
      'DELIVERED',
    ];

    if (shipperStatuses.includes(item.sell_consignments?.shipper?.status)) {
      return 'En Route to Kick Avenue';
    }

    const isConsignmentApprovedStatusWhenSellConsignmentsIsNewStatus = item.status === 'consignment_approved' && item.sell_consignments?.status === 'NEW';

    if (isConsignmentApprovedStatusWhenSellConsignmentsIsNewStatus) {
      return 'Consignment Approved';
    }

    if (item.status === 'awaiting_review') {
      return 'Awaiting Review';
    }

    if (item.status === 'awaiting_consignment') {
      return 'Awaiting Consignment';
    }

    if (item.status === 'under_review') {
      return 'Under Review';
    }

    if (item.status === 'draft') {
      return 'Draft';
    }

    const showConsignmentApprovedStatus = item.sell_consignments?.status === 'CONSIGNMENT_APPROVED' && item.sell_consignments?.shipper?.status === 'NEW';

    if (showConsignmentApprovedStatus) {
      return 'Consignment Approved';
    }

    return 'Need to Check';

  } else if (type === 'active') {
    const paymentStatus = [
      'VERIFYING_PAYMENT',
      'VERIFYING_BID'
    ];
    const offer = item?.offer?.[0] ?? null;
    const isContainUnderReservation = paymentStatus.includes(offer?.status);

    if (offer !== null && isContainUnderReservation) {
      return 'Under Reservation';
    }

    const status = item?.sell_consignments?.status;
    const askingPrice = parseInt(item.asking_price);
    const lowestAsk = parseInt(item.lowest_ask);
    const isSomeoneBoughtProduct = status === 'ACTIVE_CONSIGNMENT' && lowestAsk > 0;
    
    if (isSomeoneBoughtProduct) {
      if (askingPrice > lowestAsk) {
        return 'Waiting in Line';
      }

      return 'Active Consignment';
    }

    if (status === 'ACTIVE_CONSIGNMENT') {
      return 'Active Consignment';
    }
    return 'Need to Check';

  } else if (type === 'in_progress') {

    const sale = item?.sale?.length > 0;

    if (sale) {
      return 'In Progress';
    }

    return 'Need to Check';

  } else if (type === 'history') {
    const productStatus = item.status;
    const offer = item?.offer?.length > 0 ? item?.offer?.[0] : [];
    const sale = offer?.sale?.length > 0 ? offer?.sale?.[0] : [];
    const saleStatus = sale?.status;

    const completeStatus = [
      'DONE_BY_ADMIN',
      'DONE_BY_BUYER',
      'DONE_BY_CRON',
    ];

    if (completeStatus.includes(saleStatus)) {
      return 'Completed';
    }

    if (productStatus === 'consignment_rejected') {
      return 'Consignment Rejected';
    }

    const sellConsignments = item?.sell_consignments;

    if (productStatus === 'approved' && sellConsignments === null) {
      return 'Cancelled';
    }

    const sellConsignmentsStatus = sellConsignments?.status;

    if (sellConsignments === null && !item.is_approved_online_listing) {
      return 'Cancelled';
    }

    if (sellConsignmentsStatus === 'CONSIGNMENT_REJECTED') {
      return 'Consignment Rejected';
    }

    if (sellConsignmentsStatus === 'FAILED') {
      return 'Failed';
    }

    const returnedAndDoneBySellerStatus = [
      'RETURNED',
      'DONE',
    ];

    const isReturnedAndDoneBySellerStatus = returnedAndDoneBySellerStatus.includes(sellConsignmentsStatus);

    if (isReturnedAndDoneBySellerStatus) {
      return 'Returned';
    }

    if (sellConsignmentsStatus === 'CANCELLED') {
      return 'Cancelled';
    }

    if (item.is_approved_online_listing ?? false) {
      return 'Approved as Online Listing';
    }

    if (item?.offer === null) {
      return 'Need to Check';
    }

    return 'Need to Check';

  }

  return 'Need to Check'; 
}

export const handleColorStatusConsignment = (status, sku) => {
  if(!status){
    return '#242424';
  }

  const tempStatus = status.toLowerCase();

  switch (tempStatus) {
    // status for green color
    case 'in progress':
    case 'consignment approved':
    case 'active consignment':
    case 'verification passed':
    case 'completed':
    case 'en route to kick avenue':
    case 'sold':
    case 'on the way to you':
    case 'authentication process':
      return '#159953';
    
    // status for red color
    case 'need to check':
    case 'expired':
    case 'consignment rejected':
    case 'verification failed':
    case 'returned':
    case 'cancelled':
    case 'none':
    case 'under review':
    case 'awaiting consignment':
    case 'failed':
    case 'draft':
    case 'waiting in line':
    case 'awaiting review':
    case 'take out request':
      return '#e02020';
    
    // status for black color
    case 'under reservation':
      return '#242424'
    
    // status for yellow color
    case 'approved as online listing':
      return '#FFCA25';  
    default: return '#e02020';
  }
}